// Routing for the push-to-EMR "required fields" error list.
//
// Most missing fields are edited right here on the current (push-to-EMR) tab, so
// their "fix this" link scrolls to the field. But some fields are read-only here
// because they're actually edited on another tab -- e.g. insurance lives on the
// Eligibility tab -- so scrolling would land on a disabled input, a dead end.
// For those fields the link must navigate to the editable tab instead.

export const FIELD_NAME_TO_EDIT_TAB: Record<string, string> = {
  kinnser_insurance_provider_id: 'eligibility',
};

interface ErrorFieldHandlers {
  onNavigateToTab?: (tabId: string) => void;
  onScrollToField?: (fieldName: string) => void;
}

/**
 * Resolve the click action for a required-field error item: navigate to the
 * field's editable tab when it lives elsewhere, otherwise scroll to it in place.
 * Returns `undefined` when no suitable handler is available.
 */
export function resolveErrorFieldAction(
  fieldName: string,
  { onNavigateToTab, onScrollToField }: ErrorFieldHandlers
): (() => void) | undefined {
  const editTab = FIELD_NAME_TO_EDIT_TAB[fieldName];
  if (editTab && onNavigateToTab) {
    return () => onNavigateToTab(editTab);
  }
  if (onScrollToField) {
    return () => onScrollToField(fieldName);
  }
  return undefined;
}
